import {matchPath} from "react-router-dom";

export const activePathCheck = (currentUrl, urls) => {
  let result = false;
  const isPathActive = (url) => matchPath(
    currentUrl,
    url
  );
  urls.forEach(path=> {
    if (isPathActive(path)) {
      result = true
    }
  })
  return result
}
